export enum Currency {
  ETH = "ETH",
  BTC = "BTC",
  EUR = "EUR",
  USDT = "USDT",
  EURT = "EURT",
  MATIC = "MATIC",
  CRP = "CRP",
}